import * as React from 'react';
import * as classNames from 'classnames';
import {withI18n, WithI18nProps} from '@shopify/react-i18n';
import {Button} from '@shopify/polaris';
import {TaxonomyNode} from 'sections/types';
import {EVENTS, KeyCodes} from 'global-constants';
import ServiceItems from './ServiceItems';
import SecondaryItems from './SecondaryItems';
import {LoginModalContext} from '../login-modal/LoginModal';

import * as styles from './NavigationMobile.scss';

interface OwnProps {
  id: string;
  expanded: boolean;
  navItems: TaxonomyNode[];
  onClose(): void;
  onLoginModalPrompt(context: LoginModalContext): () => void;
}

type CombinedProps = OwnProps & WithI18nProps;

class NavigationMobile extends React.PureComponent<CombinedProps> {
  closeNavigation = (evt: Event) => {
    const {expanded, onClose} = this.props;

    if (
      evt.type === EVENTS.keydown &&
      (evt as KeyboardEvent).keyCode === KeyCodes.esc &&
      expanded
    ) {
      onClose();
    }
  };

  componentDidMount() {
    window.addEventListener(EVENTS.keydown, this.closeNavigation);
  }

  componentWillUnmount() {
    window.removeEventListener(EVENTS.keydown, this.closeNavigation);
  }

  render() {
    const {
      id,
      expanded,
      onClose,
      navItems,
      onLoginModalPrompt,
      i18n,
    } = this.props;
    const classList = classNames(styles.Navigation, {
      [styles.NavigationExpanded]: expanded,
    });

    const Overlay = (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div className={styles.Overlay} onClick={onClose} />
    );

    const CloseButton = (
      <div className={styles.CloseButton}>
        <Button
          accessibilityLabel={i18n.translate(
            'Global.MobileNavigation.closeButtonText'
          )}
          ariaControls="NavigationDrawer"
          ariaExpanded={expanded}
          icon="cancel"
          plain
          onClick={onClose}
        />
      </div>
    );

    return (
      <div className={classList}>
        {Overlay}
        <div id={id} className={styles.Drawer} aria-hidden={!expanded}>
          <nav>
            {CloseButton}
            <div className={styles.NavigationSection}>
              <ServiceItems list={navItems} onSelectItem={onClose} />
            </div>
            <div className={styles.NavigationSection}>
              <SecondaryItems onLoginModalPrompt={onLoginModalPrompt} />
            </div>
          </nav>
        </div>
      </div>
    );
  }
}

export default withI18n()(NavigationMobile);
